import { PaymentInstructionsManager } from "@/features/payments/payment-instructions-manager";
import { NetTermsManager } from "@/features/payments/net-terms-manager";

export function PaymentSettingsScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Payment Settings</h1>
        <p className="text-gray-600 mt-2">
          Configure payment instructions and terms
        </p>
      </div>
      <div className="space-y-4">
        <PaymentInstructionsManager />
        <NetTermsManager />
      </div>
    </div>
  );
}
